import {
	createFileRoute,
	Outlet,
	useParams,
	useRouterState,
} from "@tanstack/react-router";
import { JobWorkspaceAssetsTable } from "@/features/jobs/components/job-workspace-assets-table";
import { isNestedAssetWorkspacePath } from "@/features/jobs/lib/is-nested-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets",
)({
	component: JobWorkspaceAssetsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Job workspace Assets tab — table shell with outlet for asset drawer / nested workspace.
 */
function JobWorkspaceAssetsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets",
	});
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	if (isNestedAssetWorkspacePath(pathname)) {
		return <Outlet />;
	}

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<JobWorkspaceAssetsTable orgId={params.orgId} jobId={params.jobId} />
			<Outlet />
		</div>
	);
}
